export default "__VITE_ASSET__Dnnzj$QW__"